import executeRequest from "Infrastructure/WebClient";
import * as RequestTypes from "Application/RequestTypes";
import { LoginRequest } from "Domain/User/Dto/LoginRequest";
import { User } from "Domain/User/Entity/User";
import { eventDispatcher } from "pages/Hooks/useEventListener";
import { LOGGED_IN, SNACK_NOTIFICATION } from "pages/constants/EventKeys";
import authService from "./AuthService";

import { setUserData } from "./UserService";
import { SetUserRights } from "./UserRightsService";

export async function LoginUser(loginRequest: LoginRequest) {
  return executeRequest(RequestTypes.LOGIN, loginRequest).then((res: any) => {
    if (res?.error) {
      return tearDownApp();
    }
    setupApp().then(() => {
      eventDispatcher(LOGGED_IN);
    });
    return res;
  });
}

export async function Logout() {
  return executeRequest(RequestTypes.LOGOUT)
    .then((res) => {
      return tearDownApp();
    })
    .then((r) => {
      setTimeout(() => {
        window.location.reload();
      }, 500)
    });
}

export async function GetMyRights() {
  return executeRequest(RequestTypes.MY_RIGHTS).then((res) => {
    SetUserRights(res);
    return res;
  });
}

export async function GetMyData() {
  return executeRequest<User>(RequestTypes.MY_DATA).then((res: any) => {
    setUserData(res);
    return res;
  });
}

export async function tearDownApp() {
  localStorage.clear();
  authService.setAuthenticated(false);
}

export async function setupApp() {
  eventDispatcher(SNACK_NOTIFICATION, {
    type: "INIT_APP",
    snackVariant: "info",
  });

  return Promise.all([GetMyRights(), GetMyData()]).then((values) => {
    authService.setAuthenticated(true);
    // const [userRights, userData] = values;
    eventDispatcher(SNACK_NOTIFICATION, {
      type: "INIT_APP",
      snackVariant: "success",
    });
  });
}

export async function CheckAuth() {
  return executeRequest(RequestTypes.TOUCH).then((res) => {
    if (res === "OK") {
      return setupApp();
    } else {
      return tearDownApp();
    }
  });
}
